import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormMode } from '../../../core/constants';
import { MerchantService } from '../../../models/merchant/merchantService';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { AssignedUser } from '../../../models/users/assignedUser';

@Component({
  selector: 'app-edit-merchant-contact-dialog',
  templateUrl: './edit-merchant-contact-dialog.component.html',
  standalone: false,
})
export class EditMerchantContactDialogComponent {
  FormMode = FormMode;

  contact: AssignedUser;
  merchantId: string;

  constructor(
    public merchantService: MerchantService,
    private uiErrorHandler: UIErrorHandler,
    public dialogRef: MatDialogRef<EditMerchantContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      contact: AssignedUser;
      merchantId: string;
    },
  ) {
    this.contact = data.contact;
    this.merchantId = data.merchantId;
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  cancel() {
    this.dialogRef.close(false);
  }

  saveContact(contactToSave: AssignedUser) {
    // var that = this;

    if (this.contact && this.contact.userId != '') {
      this.contact = contactToSave;

      this.merchantService
        .patchMerchantContactInfo(this.contact)
        .then(() => {
          this.dialogRef.close({
            action: 'update',
            contact: this.contact,
          });
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    } else {
      this.merchantService
        .insertMerchantContactInfo(contactToSave, this.merchantId)
        .then((savedContact: AssignedUser) => {
          this.contact = contactToSave;

          this.dialogRef.close({
            action: 'insert',
            contact: contactToSave,
          });
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }

  deleteContact(event: any) {
    if (!confirm('Are you sure?')) {
      return;
    }

    this.merchantService
      .deleteMerchantContactInfo(this.merchantId, this.contact.userId)
      .then(() => {
        this.dialogRef.close({
          action: 'delete',
          userId: this.contact.userId,
        });
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }
}
